<div class="di-part-facturation">
	<small>{{ label }}</small>
	<div class="di-part-facturation-row">
		<h4 [ngClass]="statusClass">
			{{ amount ? ((avoir ? '-' : '') + (amount | priceFormat:2)) : '-' }}
		</h4>
		<di-tag-suivi-facture *ngIf="showtags" [etat]="status" [forceLabel]="labelStatus ?? null"></di-tag-suivi-facture>
	</div>
</div>